export default __webpack_public_path__ + "static/slide-06-RES-cb8a7439f39f6c79375592d44a859df1.jpg";